export default __webpack_public_path__ + "static/media/Close-icon.8c0cc206.svg";